import { mapLegacyAccessPromiseToServiceFnPromise } from 'app/services/http/utils'
import { getCurrentOwners } from 'app/sm/inspections/inspections_access'

interface GetPropertyOwnersOptions {
  filterOptedOut?: boolean
}

export const getPropertyOwners = (
  teamId: string,
  propertyId: string,
  options: GetPropertyOwnersOptions = {},
) => {
  return mapLegacyAccessPromiseToServiceFnPromise(
    getCurrentOwners(teamId, propertyId, options),
  )
}
